import { fmtDateZA } from '@/lib/dates'

/**
 * The board loaded, but the saved filters / search / status chip match no
 * delivery. A search term from last week is still in the field when the board
 * opens, so "No deliveries — log it here" would be the wrong answer: say that
 * the filters narrowed it, name the 90-day window, and offer the two ways out.
 */
export function DeliveriesNoMatch({ windowFromIso, searchTerm, onShowAllHistory, onClear }: {
  /** The 90-day window's start; null when All history (or an earlier From date) is on. */
  windowFromIso: string | null
  searchTerm: string
  onShowAllHistory: () => void
  onClear: () => void
}) {
  return (
    <div className="text-center py-10 space-y-2" data-testid="deliveries-no-match">
      <p className="text-sm text-fg-secondary">
        {searchTerm ? `No deliveries match "${searchTerm}" and your other filters.` : 'No deliveries match these filters.'}
      </p>
      {windowFromIso && (
        <>
          <p className="text-xs text-fg-muted">Looked at {fmtDateZA(windowFromIso)} to today. Older deliveries are hidden.</p>
          <button type="button" className="btn-ghost btn-sm min-h-[44px]" onClick={onShowAllHistory}>Show all history</button>
        </>
      )}
      <div>
        <button type="button" className="btn-ghost btn-sm min-h-[44px]" onClick={onClear}>Clear filters</button>
      </div>
    </div>
  )
}
